import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { faAngleRight, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import IconAddBlueBorder from '../../../assets/icons/IconAddBlueBorder';
import IconKMSPencilAction from '../../../assets/icons/IconKMSPencilAction';
import IconKMSDeleteAction from '../../../assets/icons/IconKMSDeleteAction';
import TableNexcare from '../../../components/Table/TableNexcare';
import API_NEWS_FEED from '../../../api/apiNewsFeed';
import Alert from '../../../components/Alert/Alert';
import { CheckPermissionComponent } from '../../../util/permission';
import { SETTING_KMS_DELETE, SETTING_KMS_INSERT, SETTING_KMS_UPDATE } from '../../../constants/menuPermissionConstant';

class NewsFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            filter: {
                field: '',
                ascending: false,
                descending: false,
            },
            columns: [
                {
                    title: "ID",
                    dataIndex: "id",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    sorter: true,
                    width: "w-2/12",
                    render: (data) => `${data}`,
                },
                {
                    title: "Judul",
                    dataIndex: "title",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Tanggal Pembuatan",
                    dataIndex: "created_at",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data === "" ? "-" : moment.utc(data).format('DD/MM/YYYY HH:mm')}`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => (
                        <div className="flex items-center justify-between">
                            <div className="flex space-x-10">
                                <CheckPermissionComponent permissionConstant={[SETTING_KMS_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                    <div id="btnedit" className="w-7 h-7 flex justify-center items-center cursor-pointer" onClick={() => this.handleNewsFeedEdit(data)}>
                                        <IconKMSPencilAction />
                                    </div>
                                </CheckPermissionComponent>
                                <CheckPermissionComponent permissionConstant={[SETTING_KMS_DELETE]} userPermission={this.props.userDetail.permissions}>
                                    <div id="btndelete" className="w-7 h-7 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showConfirmAlert: true, newsFeedDataSelectedDelete: data })}>
                                        <IconKMSDeleteAction />
                                    </div>
                                </CheckPermissionComponent>
                            </div>
                            <div id="btnview" className="bg-black rounded-full w-7 h-7 flex justify-center items-center cursor-pointer" onClick={() => this.handleNewsFeedDetail(data)}>
                                <FontAwesomeIcon icon={faAngleRight} className="text-white text-2xl" />
                            </div>
                        </div>
                    ),
                },
            ],
            newsFeedId: null,
            listNewsFeed: [],
            searchKey: '',
            showConfirmAlert: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleNewsFeedAdd = () => {
        this.props.history.push(ROUTER_CONSTANT.SETTINGS_NEWS_FEED_ADD);
    }

    handleNewsFeedEdit = value => {
        this.props.history.push(ROUTER_CONSTANT.SETTINGS_NEWS_FEED_EDIT.split(':')[0] + value.id);
    }

    handleNewsFeedDetail = value => {
        this.props.history.push(ROUTER_CONSTANT.SETTINGS_NEWS_FEED_DETAIL.split(':')[0] + value.id);
    }

    handleSearch = e => {
        if (e.key === "Enter") {
            let defaultCurrent = 1;
            let defaultPageSize = 10;
            this.setState({
                pagination: {
                    ...this.state.pagination,
                    current: defaultCurrent,
                    pageSize: defaultPageSize
                }
            }, () => {
                let sorterValue = this.getSorterValueFunction(this.state.filter);
                if (this.state.searchKey === '') {
                    this.getListNewsFeedInitiate();
                    this.getListNewsFeed(this.state.pagination.current, this.state.pagination.pageSize, sorterValue);
                    return;
                }

                this.getListNewsFeedSearchInitiate(this.state.searchKey);
                this.getListNewsFeedSearch(defaultCurrent, defaultPageSize, sorterValue, this.state.searchKey);
            })
        }
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                let sorterValue = this.getSorterValueFunction(this.state.filter);
                this.getListNewsFeedSearch(this.state.pagination.current, this.state.pagination.pageSize, sorterValue, this.state.searchKey);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                let sorterValue = this.getSorterValueFunction(this.state.filter);
                this.getListNewsFeedSearch(this.state.pagination.current, this.state.pagination.pageSize, sorterValue, this.state.searchKey);
            }
        );
    }

    handleSorter = sorter => {
        this.setState(
            {
                filter: sorter
            },
            () => {
                let sorterValue = this.getSorterValueFunction(this.state.filter);
                this.getListNewsFeedSearch(this.state.pagination.current, this.state.pagination.pageSize, sorterValue, this.state.searchKey);
            }
        );
    }

    handleDeleteNewsFeed = () => {
        this.setState({ showConfirmAlert: false })
        const newsFeedId = this.state.newsFeedDataSelectedDelete.id;
        const data = { updated_at: this.state.newsFeedDataSelectedDelete.updated_at };
        API_NEWS_FEED.deleteDataNewsFeed(newsFeedId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({ showSuccessAlert: true })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    handleSuccessDeleteNewsFeed = () => {
        this.setState({
            showSuccessAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            let sorterValue = this.getSorterValueFunction(this.state.filter);
            this.getListNewsFeedInitiate(this.state.categoryId);
            this.getListNewsFeed(this.state.pagination.current, this.state.pagination.pageSize, sorterValue);
        })
    }

    getSorterValueFunction = value => {
        if (value.ascending) {
            return "ASC"
        }
        if (value.descending) {
            return "DESC"
        }
        return "ASC"
    }

    getListNewsFeedInitiate = () => {
        API_NEWS_FEED.getListNewsFeedInitiate(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: { ...this.state.pagination, total: getContent(res).count_data }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListNewsFeed = (current, pageSize, sorter) => {
        API_NEWS_FEED.getListNewsFeed(current, pageSize, sorter, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listNewsFeed: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListNewsFeedSearchInitiate = (key) => {
        API_NEWS_FEED.getListNewsFeedSearchInitiate(key, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: { ...this.state.pagination, total: getContent(res).count_data }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListNewsFeedSearch = (current, pageSize, sorter, key) => {
        API_NEWS_FEED.getListNewsFeedSearch(current, pageSize, sorter, key, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listNewsFeed: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    componentDidMount() {
        this._isMounted = true;

        let sorterValue = this.getSorterValueFunction(this.state.filter);
        this.getListNewsFeedInitiate();
        this.getListNewsFeed(this.state.pagination.current, this.state.pagination.pageSize, sorterValue);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <div className="h-full pb-5">
                <BreadCrumbs
                    parentMenu="Pengaturan"
                    serviceMenu="Berita"
                    title="Berita"
                />

                <div className="space-y-3">
                    {/* FILTER */}
                    <div className="flex justify-between items-center">
                        <div className="bg-white w-1/4 h-12 rounded p-3 mt-1 focus-within:border-gray-400 border">
                            <div className="flex items-center rounded-full bg-white px-2">
                                <input id="tslsearch" type="text" placeholder={"Cari Judul"} className="outline-none w-full" value={this.state.searchKey} onKeyDown={this.handleSearch} onChange={(e) => { this.setState({ searchKey: e.target.value }) }} />
                                <div>
                                    <FontAwesomeIcon icon={faSearch} className="text-gray-400" />
                                </div>
                            </div>
                        </div>

                        {/* Add News Feed */}
                        <CheckPermissionComponent permissionConstant={[SETTING_KMS_INSERT]} userPermission={this.props.userDetail.permissions}>
                            <div
                                id="btnadd"
                                className="flex items-center cursor-pointer bg-olddarkblue text-white py-2 px-6 rounded-lg"
                                onClick={this.handleNewsFeedAdd}
                            >
                                <IconAddBlueBorder />
                                <span className="ml-2">Tambah Berita</span>
                            </div>
                        </CheckPermissionComponent>
                    </div>

                    {/* CONTENT */}
                    <div className="bg-white rounded-2xl">
                        <TableNexcare
                            column={this.state.columns}
                            dataTable={this.state.listNewsFeed}
                            pagination={this.state.pagination}
                            onPage={this.handleSelectedPage}
                            onPageSize={this.handleSelectedPageSize}
                            onSorter={this.handleSorter}
                        />
                    </div>
                </div>

                <Alert show={this.state.showConfirmAlert} button={true} title="Hapus Berita?" desc={"Apakah Anda yakin ingin menghapus data?"} close={() => this.setState({ showConfirmAlert: false, newsFeedDataSelectedDelete: {} })} submit={() => this.handleDeleteNewsFeed()} />
                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil" desc={"Data berhasil dihapus"} close={this.handleSuccessDeleteNewsFeed} ok />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsFeed);